import React, { useState } from "react";
import { Form, Col, Row, Button, Table } from "react-bootstrap";
import CustomTooltip from "utils/CustomTooltip";
import jsDig from "utils/jsDig";
import CustomFormCheck from "utils/CustomFormCheck";

export default function RootDomains(props) {
  const [rootDomains, setRootDomains] = useState(
    jsDig(["search_console", "root_domains"], props.platformData) ? jsDig(["search_console", "root_domains"], props.platformData) : []
  );
  const websites = [
    jsDig(["primary"], props.websites),
    ...(jsDig(["additional"], props.websites) ? jsDig(["additional"], props.websites) : []).map((website) => website.url),
  ];

  const handleDelete = (targetIndex) => {
    let newIds = rootDomains.filter((id, index) => {
      return targetIndex != index;
    });
    setRootDomains(newIds);
  };

  const handleChange = (targetIndex, property, value) => {
    let newIds = rootDomains.map((id, index) => {
      let newId = id;
      if (index == targetIndex) {
        newId[property] = value;
      }
      return newId;
    });
    setRootDomains(newIds);
  };
  return (
    <>
      <Row className="pb-3 mt-3 pt-3">
        <Col>
          <div className="d-flex align-items-center">
            <span className="green f18 visby-bold center-it">Root Domain</span>
            <CustomTooltip
              faClass="far green fa-question-circle f18 pl-2"
              message="The root domain is the highest level of the architecture of a website, or the base of a URL. You should include any potential variations of your website (inclusion of www, etc.)
                "
              inline={true}
            />
          </div>
          <br></br>
          <p className="f14 primary">
            Your root domain(s) are auto-filled from what you entered as the website in account configuration, but you can change them here if need be.
          </p>
        </Col>
      </Row>
      {/* <Row className=" ml-2">
        <CustomFormCheck id={`domain_property`} dynamic checked={props.seo_section.domain_property} name={`domain_property`} />
        <Col>Domain Property</Col>
      </Row> */}
      <Row className="py-3 px-0">
        <Col>
          <div className="table-responsive">
            <Table className="overflow-hidden">
              <tbody>
                {rootDomains.map((rootDomain, index) => {
                  return (
                    <tr key={index}>
                      <td className="pl-0">
                        <Form.Control
                          size="sm"
                          as="select"
                          name={`[search_console_root_domains][${index}][website]`}
                          value={jsDig(["website"], rootDomain) ? jsDig(["website"], rootDomain) : ""}
                          onChange={(e) => handleChange(index, "website", e.target.value)}>
                          <option value="" hidden disabled>
                            Choose one
                          </option>
                          {websites.map((website) => {
                            return (
                              <option key={website} value={website}>
                                {website}
                              </option>
                            );
                          })}
                        </Form.Control>
                      </td>
                      <td>
                        <Form.Control
                          size="sm"
                          name={`[search_console_root_domains][${index}][root_domain]`}
                          value={jsDig(["root_domain"], rootDomain) ? jsDig(["root_domain"], rootDomain) : ""}
                          onChange={(e) => handleChange(index, "root_domain", e.target.value)}
                        />
                      </td>
                      <td>
                        {(index >= 0 && rootDomains.length > 1) && (
                          <i
                            className=" pl-2 fas fa-minus-circle"
                            onClick={(e) => {
                              handleDelete(index);
                            }}></i>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
            <Button
              className="mt-3 mb-3 ml-2 mr-4 px-4 py-1"
              size="sm"
              as="input"
              type="button"
              onClick={(e) => {
                setRootDomains((prevState) => [...prevState, {}]);
              }}
              value="+ Add"
              variant="success"
            />
          </div>
        </Col>
      </Row>
    </>
  );
}
